<template>
    <div id="app">

        <router-view/>

        <div class="logo">
            <img src="./assets/img/logo.svg" alt="Logo">
        </div>
        <div class="tabs">
            <div id="nav">
                <div v-for="(step, index) in steps" :key="index"
                     :class="{'active': stepActive == index+1, 'step-finish': index == 5,'hidden': index==10 }"><a
                        href="javascript:void(0);"
                        :class="{'active': stepActive == index+1, 'done': stepActive > index+1 }">{{ step }}</a></div>
            </div>
            <div id="tabs-body">

                <div id="step-1" :class="{'active': stepActive === 1}">
                    <FirstStep ref="step1" @openNextPage="firstStepNextPage"/>
                </div>

                <div id="step-2" :class="{'active': stepActive === 2}">
                    <SecondStep ref="step2" @openNextPage="secondStepNextPage"/>
                </div>

                <div id="step-3" :class="{'active': stepActive === 3}">
                    <ThirdStep ref="step3" @openNextPage="thirdStepNextPage"/>
                </div>

                <div id="step-4" :class="{'active': stepActive === 4}">
                    <FourthStep ref="step4" @openNextPage="fourthStepNextPage"/>
                </div>

                <div id="step-5" :class="{'active': stepActive === 5}">
                    <Conclusion ref="step5" @jumpTo="jumpTo" @openNextPage="fifthStepNextPage"/>
                </div>

                <div id="step-6" :class="{'active': stepActive === 6}">
                    <Success ref="step6"/>
                </div>

                <div class="container prevnext-buttons" v-if="stepActive != 6">
                    <div class="row">
                        <div class="col-6 back-button">
                            <a href="javascript:void(0);" tag="button" class="button" v-on:click="prevPage()"
                               v-if="stepActive > 1 && stepActive < 6">Zurück</a>
                        </div>
                        <div class="col-6 next-button" v-if="stepActive < 5">
                            <a href="javascript:void(0);" tag="button" class="button" v-on:click="nextPage()">Weiter</a>
                        </div>
                        <div class="col-6 submit-button" v-if="stepActive == 5">
                            <a href="javascript:void(0);" tag="button" class="button" v-on:click="nextPage()">Anfrage
                                jetzt versenden</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>


        <modals-container/>
        <v-dialog/>
    </div>

</template>

<script>
    import FirstStep from './views/FirstStep'
    import SecondStep from './views/SecondStep'
    import ThirdStep from './views/ThirdStep'
    import FourthStep from './views/FourthStep'
    import Conclusion from './views/Conclusion'
    import Success from './views/Success'


    import 'vue-datetime/dist/vue-datetime.css'

    export default {
        name: 'teacherform',
        components: {
            FirstStep,
            SecondStep,
            ThirdStep,
            FourthStep,
            Conclusion,
            Success
        },

        data: function () {
            return {
                steps: ['Unterrichtsfach', 'Nachhilfeort', 'Qualifikation', 'Persönliches', 'Fast Fertig', 'Fertig'],
                stepActive: 1,

                firstStepData: [],
                secondStepData: [],
                thirdStepData: [],
                fourthStepData: [],
                fifthStepData: [],
            }
        },

        mounted: function () {

        },

        methods: {
            prevPage() {
                this.stepActive--;
            },
            nextPage() {
                switch (this.stepActive) {
                    case 1:
                        this.$refs.step1.nextPage();
                        break;
                    case 2:
                        this.$refs.step2.nextPage();
                        break;
                    case 3:
                        this.$refs.step3.nextPage();
                        break;
                    case 4:
                        this.$refs.step4.nextPage();
                        break;
                    case 5:
                        this.$refs.step5.nextPage();
                        break;
                }
            },
            firstStepNextPage(data) {
                this.firstStepData = data;
                this.stepActive = 2;
                window.scrollTo(0, 0);
            },
            secondStepNextPage(data) {
                this.secondStepData = data;
                this.stepActive = 3;
                window.scrollTo(0, 0);
            },
            thirdStepNextPage(data) {
                this.thirdStepData = data;
                this.stepActive = 4;
                window.scrollTo(0, 0);
            },
            fourthStepNextPage(data) {
                this.fourthStepData = data;
                this.stepActive = 5;
                window.scrollTo(0, 0);
            },
            fifthStepNextPage(data) {
                this.fifthStepData = data;
                this.stepActive = 6;
            },

            jumpTo(step) {
                this.stepActive = step;
                window.scrollTo(0, 0);
            },

            dateFormatReadable: function (value) {
                if (!value) return ''
                var d = new Date(value)
                return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2);
            },

            implode: function (array) {
                var string = '';
                array.forEach(function (item) {
                    string = item['subject'] + ', ' + string;
                })
                string = string.slice(0, -2);
                return string;
            },

            dateFormat: function (value) {
                if (!value) return null
                var d = new Date(value)
                return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + ' ' + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2) + ":" + ('0' + d.getSeconds()).slice(-2);
            },

            apiPost: function (topic, data) {
                const header = {
                    headers: {
                        'x-api-key': 'ae22802869969617eb987dd8c0c9d605',
                        'Content-Type': 'application/json'
                    }
                }
                this.$http.post('https://crm.mueller-helpings.de/api/v1/' + topic, data, header)
                    .then((res) => {
                        return res;
                    })
                    .catch((err) => {
                        console.error(err)
                        return false
                    })

            },
            apiGet: async function (topic) {
                const header = {
                    headers: {
                        'x-api-key': 'ae22802869969617eb987dd8c0c9d605',
                        'Content-Type': 'application/json'
                    }
                }
                let response = await this.$http.get('https://crm.mueller-helpings.de/api/v1/' + topic, header)
                    .then((res) => {
                        return res.data
                    })
                    .catch((err) => {
                        console.error(err)
                        return false
                    })
                console.log(response)
                return (response)
            },
            demoApiCall: function () {
                const data = JSON.stringify({
                    salutationName: 'Mr.',
                    firstName: 'Konstantin',
                    lastName: 'Vogeler',
                    status: 'Bewerbung',
                })
                const header = {
                    headers: {
                        'x-api-key': 'ae22802869969617eb987dd8c0c9d605',
                        'Content-Type': 'application/json'
                    }
                }
                this.$http.post('https://crm.mueller-helpings.de/api/v1/Teacher', data, header)
                    .then((res) => {
                        console.log(res);
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
        }
    }
</script>

<style lang="less">
    @import "./assets/vendor/fontawesome/less/fontawesome";
    @import "./assets/vendor/fontawesome/less/solid";
    @import './assets/less/style.less';

    #nav {
        display: flex;
        background: #a7a7a7;
        line-height: 1rem;
        position: relative;


        div {
            width: 25%;

        }

        a {
            /*display: none;*/
            .font2;
            color: #fff;
            text-decoration: none;
            font-size: 1.5rem;
            line-height: 1.5rem;
            display: block;
            width: 100%;
            box-shadow: 0 0 3px #333;
            padding: 1.5rem;
            box-sizing: border-box;
            text-align: center;
            cursor: default;
            background: #a7a7a7;
            overflow: hidden;
            white-space: nowrap;

            &.active {
                display: inline-block;
                background-color: @primary;
                position: relative;
                z-index: 1;
                padding-top: 2rem;
                margin-top: -1rem;
                padding-bottom: 2rem;
            }

            &.done {
                background-color: #6f6f6f;
            }
        }

        i {
            margin-right: 0.5rem;
        }

        .hidden {
            display: none;
        }

        .step-finish {
            display: none;
            position: absolute;
            width: 100%;
            background: #4d9aa2;
            box-sizing: border-box;

            &.active {
                display: block;
                width: 100%;
                left: 0;
            }
        }

        @media (max-width: 850px) {
            div {
                width: 13%;
            }

            div.active {
                width: 50%;
            }
        }
    }

    .logo {
        position: absolute;
        width: 100%;
        height: 110px;
        display: flex;
        justify-content: center;

        img {
            max-width: 270px;
            width: 100%;
            height: auto;
        }

        @media (max-width: 850px) {
            position: relative;
            top: 0;
            margin: 0;
            transform: none;
            left: 0;
        }
    }

    .tabs {
        top: 120px;
        width: 90%;
        max-width: 800px;
        margin: 0 auto;
        padding: 1rem;
        position: relative;

        #tabs-body {
            position: relative;
            z-index: 10;
            background-color: #ffffff;
            box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
            padding: 3rem;

            > div:not(.prevnext-buttons) {
                display: none;

                &.active {
                    display: block;
                }
            }
        }

        @media (max-width: 850px) {
            top: 0;
            transform: none;
        }

    }

    .prevnext-buttons {
        margin-top: 5rem;

        .next-button, .submit-button {
            text-align: right;
        }

        .back-button a {
            padding: 0.7rem;
            margin-top: 1.4rem;
        }
    }

</style>